import { persistResumableFields, restoreResumableFields, setForm } from "@github/session-resume"

function getPageID() {
  return window.location.pathname
}

// Listen for all form submit events and to see if their default submission
// behavior is invoked.
window.addEventListener("submit", setForm, { capture: true })

// Resume field content on regular page loads.
window.addEventListener("pageshow", function () {
  restoreResumableFields(getPageID(), { storage: window.localStorage })
})

// Persist resumable fields when page is unloaded
window.addEventListener("pagehide", function () {
  persistResumableFields(getPageID(), { storage: window.localStorage })
})
